<template>
  <svg width="184" height="88" viewBox="0 0 184 88" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M118.661 0.000583649L145.92 42.2617C145.92 42.2617 124.042 39.3244 117.705 27.3357C111.308 15.405 118.661 0.000583649 118.661 0.000583649Z"
      fill="#ED6B1F"
    />
    <path
      d="M139.399 1.53992L145.855 42.2427C145.855 42.2427 130.432 32.771 129.595 21.6811C128.818 10.651 139.399 1.53992 139.399 1.53992Z"
      fill="#2F7DC1"
    />
    <path
      d="M129.642 21.7465C130.478 32.8364 145.901 42.3081 145.901 42.3081L129.88 17.4918C129.642 18.8092 129.522 20.248 129.642 21.7465Z"
      fill="#21ABD9"
    />
    <path
      d="M0 34.2145H20.9218V40.5677H7.23351V47.7018H19.0099V53.7559H7.23351V67.3628H0V34.2145Z"
      fill="white"
    />
    <path
      d="M23.7271 44.8146H30.5414V47.8118L30.6606 47.8716C32.2147 45.6536 34.4265 44.5156 37.1768 44.5156C37.6556 44.5156 38.1327 44.5754 38.6115 44.695V51.2293C38.073 
        51.1097 37.3557 50.9901 36.7593 50.9901C34.3686 50.9901 32.3357 51.7095 30.722 53.6285V67.2354H23.7884L23.7271 44.8146Z"
      fill="white"
    />
    <path
      d="M56.497 53.4696C56.0778 51.0722 54.2852 49.5736 52.0734 49.5736C49.9212 49.5736 48.069 50.8928 47.4709 53.4696H56.497ZM47.5305 57.9056C48.3075 61.0223 50.8772 
        62.4611 54.0467 62.4611C56.5566 62.4611 59.3069 61.5623 61.638 60.0039V65.8189C59.4262 67.1978 56.0795 67.8574 53.0907 67.8574C45.6783 67.8574 40.3584 63.2421 
        40.3584 56.1678C40.3584 48.9739 45.9168 44.2987 52.1348 44.2987C57.6336 44.2987 62.8342 47.9555 62.8342 55.5082C62.8342 56.2874 62.7746 57.3058 62.7149 
        57.9056H47.5305Z"
      fill="white"
    />
    <path
      d="M82.0981 53.4686C81.6789 51.0712 79.8863 49.5727 77.6745 49.5727C75.5223 49.5727 73.6701 50.8918 73.072 53.4686H82.0981ZM73.1316 57.9046C73.9086 61.0214 76.4782 
        62.4601 79.6477 62.4601C82.1577 62.4601 84.908 61.5613 87.239 60.003V65.8179C85.0272 67.1969 81.6806 67.8564 78.6918 67.8564C71.2794 67.8564 65.9595 63.2411 65.9595 
        56.1668C65.9595 48.9729 71.5179 44.2977 77.7359 44.2977C83.2347 44.2977 88.4353 47.9545 88.4353 55.5072C88.4353 56.2864 88.3756 57.3048 88.316 57.9046H73.1316Z"
      fill="white"
    />
    <path
      d="M107.865 50.9344C106.849 50.4542 105.653 50.0356 104.278 50.0356C100.631 50.0356 98.6579 52.7935 98.6579 56.1495C98.6579 59.5055 100.572 62.084 103.978 
        62.084C105.472 62.084 106.847 61.6039 107.863 60.9443L107.865 50.9344ZM107.926 66.0996C106.432 67.1778 104.399 67.8374 102.247 67.8374C96.5671 67.8374 91.7261 
        63.4613 91.7261 56.5681C91.7261 49.4956 96.8671 44.3402 103.562 44.3402C105.235 44.3402 106.611 44.6392 107.807 45.1792L107.926 45.1194V32.4114H114.86V67.359H108.045V66.1594L107.926 66.0996Z"
      fill="white"
    />
    <path
      d="M131.442 61.8454C134.609 61.8454 137 59.2686 137 56.0903C137 52.912 134.609 50.3352 131.442 50.3352C128.274 50.3352 125.883 52.912 125.883 56.0903C125.883 59.2686 
        128.333 61.8454 131.442 61.8454ZM131.442 44.2828C138.615 44.2828 143.935 49.3784 143.935 56.0323C143.935 62.6862 138.615 67.7817 131.442 67.7817C124.268 67.7817 
        118.948 62.6862 118.948 56.0323C118.948 49.3784 124.327 44.2828 131.442 44.2828Z"
      fill="white"
    />
    <path
      d="M177.123 54.3464C177.123 52.6684 176.824 51.8892 176.286 51.2894C175.628 50.6298 174.851 50.3308 173.895 50.3308C172.282 50.3308 170.668 51.1698 169.472 
        52.1882C169.531 52.4872 169.531 52.8478 169.531 53.2066V67.3535H162.598V54.3464C162.598 52.8478 162.359 51.949 161.761 51.2894C161.103 50.6298 160.326 50.3308 
        159.37 50.3308C157.757 50.3308 156.143 51.2296 155.006 52.1882V67.3535H148.073V44.8747H154.887V46.9133L155.006 46.9731C156.739 45.5343 159.011 44.3963 161.761 
        44.3963C164.152 44.3963 166.962 45.3549 168.277 47.5729C170.668 45.4147 173.358 44.3963 176.168 44.3963C178.678 44.3963 180.652 45.2353 181.967 46.6143C183.402 
        48.053 184 50.0318 184 53.2682V67.415H177.066L177.123 54.3464Z"
      fill="white"
    />
    <path
      d="M157.979 74.0746H160.227V70.7242L164.364 69.707V74.0746H167.978V77.5348H164.364V82.3412C164.364 83.7672 164.965 84.5101 166.198 84.5101C166.83 84.5101 167.486 
        84.3156 167.978 84.1261V87.4218C167.292 87.7509 166.173 88.0002 165.02 88.0002C161.788 88.0002 160.227 86.1604 160.227 82.785V77.5398H157.979V74.0746Z"
      fill="#2F7DC1"
    />
    <path
      d="M168.853 74.0742H173.233L174.819 78.4418C175.341 79.8977 175.859 81.3785 176.326 82.7795H176.381C176.873 81.3785 177.45 79.8429 177.997 78.4119L179.667 
        74.0742H183.774L178.3 87.6906H174.327L168.853 74.0742Z"
      fill="#2F7DC1"
    />
  </svg>
</template>
